/* eslint-disable @typescript-eslint/no-unused-vars */
import { assign, DoneInvokeEvent } from 'xstate';
import { CreditCardFields } from '@chargify/payments-sdk';
import { AddressFields } from '@chargify/address';

import {
  Context,
  PaymentProfileReplacementResponse,
  ResetFieldErrorEvent,
  SetPaymentProfileIdForReplacementEvent,
} from './types';
import { PaymentProfile } from '../../models/paymentProfile';

export const resetFieldError = assign({
  billingAddress: (context: Context, event: ResetFieldErrorEvent) => {
    const { form, field } = event as ResetFieldErrorEvent & {
      field: keyof AddressFields;
    };
    if (form === 'billingAddress') {
      const { [field]: _error, ...restErrors } = context.billingAddress.errors;
      return {
        ...context.billingAddress,
        errors: restErrors,
      };
    }
    return context.billingAddress;
  },
  paymentMethod: (context: Context, event: ResetFieldErrorEvent) => {
    const { form, field } = event as ResetFieldErrorEvent & {
      field: keyof CreditCardFields;
    };
    if (form === 'paymentMethod') {
      const { [field]: _error, ...restErrors } = context.paymentMethod.errors;
      return {
        ...context.paymentMethod,
        errors: restErrors,
      };
    }
    return context.paymentMethod;
  },
});

export const setPaymentProfileIdForReplacement = assign<Context>({
  paymentProfiles: (ctx, event: SetPaymentProfileIdForReplacementEvent) => {
    const { paymentProfileId } = event;
    if (ctx.paymentProfiles.idsForReplacement?.includes(paymentProfileId)) {
      return {
        ...ctx.paymentProfiles,
        idsForReplacement: ctx.paymentProfiles.idsForReplacement.filter(
          (id) => id !== paymentProfileId
        ),
      };
    }
    return {
      ...ctx.paymentProfiles,
      idsForReplacement: [
        ...ctx.paymentProfiles.idsForReplacement,
        paymentProfileId,
      ],
    };
  },
});

export const assignCreatedProfile = assign<Context>({
  createdProfile: (ctx, event: DoneInvokeEvent<PaymentProfile>) => event.data,
});

export const serializePaymentProfilesSubscriptions = assign<Context>(
  (
    ctx,
    event: DoneInvokeEvent<{
      subscriptions: {
        success: PaymentProfileReplacementResponse[];
        failed: PaymentProfileReplacementResponse[];
      };
    }>
  ) => {
    return {
      ...ctx,
      paymentProfiles: {
        idsForReplacement: event.data.subscriptions.failed.map((i) => i.id),
        subscriptions: {
          failed: event.data.subscriptions.failed,
          success: event.data.subscriptions.success,
        },
      },
    };
  }
);
